<script>
import DatePicker from "@/components/pickers/DatePicker.vue";
import TimePicker from "@/components/pickers/TimePicker.vue";
import { VInput } from "vuetify/components";

export default {
  name: "DateTimePicker",
  components: { TimePicker, DatePicker },
  extends: VInput,
  props: {
    modelValue: String,
    dateLabel: String,
    timeLabel: String,
    min: String,
    max: String,
    required: Boolean,
    dateClass: String,
    timeClass: String,
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      date: null,
      time: null,
    };
  },
  computed: {
    fullDate() {
      return this.modelValue ? this.$dayjs(this.modelValue).format("MM/DD/YYYY HH:mm") : null;
    },
  },
  watch: {
    modelValue: {
      handler(value) {
        this.setDateTime(value);
      },
      immediate: true,
    },
  },
  methods: {
    setDateTime(value) {
      if (!value) {
        this.date = null;
        this.time = null;

        return;
      }
      const [date, time] = value.split("T");
      const formattedDate = this.$dayjs(value);

      if (date) {
        this.date = formattedDate.format("YYYY-MM-DD");
      }

      if (time) {
        this.time = formattedDate.format("HH:mm");
      }
    },
    onUpdateDate(date) {
      this.emitValue(date, this.time);
    },
    onUpdateTime(time) {
      this.emitValue(this.date, time);
    },
    emitValue(date, time) {
      if (!date && !time) {
        return this.$emit("update:modelValue", null);
      }

      const result = [date, time].join("T");
      this.$emit("update:modelValue", result);
    },
    minDateValidator(value) {
      if (!this.min || !value) {
        return true;
      }

      const result =
        this.$dayjs(value).isSameOrAfter(this.$dayjs(this.min)) ||
        "Date can not be before " + this.$dayjs(this.min).format("MM/DD/YYYY HH:mm");

      return result;
    },
  },
};
</script>

<template>
  <v-row :class="dateClass">
    <v-col>
      <date-picker
        v-model="date"
        :label="dateLabel || 'Date'"
        :max="max"
        :min="min"
        :required="required"
        skip-validation
        @update:model-value="onUpdateDate"
      ></date-picker>
    </v-col>
    <v-col>
      <time-picker
        v-model="time"
        :label="timeLabel || 'Time'"
        :required="required"
        @update:model-value="onUpdateTime"
      ></time-picker>
    </v-col>
  </v-row>
  <v-row :class="timeClass">
    <v-col class="pt-0">
      <v-text-field
        :hide-details="hideDetails"
        :model-value="fullDate"
        :rules="[minDateValidator]"
        type="hidden"
        variant="plain"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped></style>
